import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'
import { backdropVariants, panelVariants } from './style/popup'
import { XMarkIcon } from '@heroicons/react/24/solid'
import popupManager from './utils/popupManager'


//FIXME - Currently not using it but maybe in the future
const Popup = () => {

    const [showPopUp, setShowPopUp] = useState(false)

    useEffect(() => {
        popupManager.subscribe(setShowPopUp)
        return () => popupManager.unsubscribe()
    }, [])

    const container = document.getElementById('popup')

    return (
        <>
            {container && showPopUp &&
                createPortal(
                    <>
                        <motion.div
                            initial='hidden'
                            animate='visible'
                            exit='hidden'
                            variants={backdropVariants}
                            className='fixed inset-0 z-[12] bg-gray-500 cursor-auto'

                        />
                        <div
                            className={`fixed inset-0 z-[12] flex min-h-full justify-center p-[1px] text-center items-center sm:p-0 `}

                        >
                            <motion.div
                                initial='hidden'
                                animate='visible'
                                exit='exit'
                                variants={panelVariants}
                                className={`justify-center flex-col p-5 bg-white relative text-left`}
                            >
                                <div className='flex justify-end'>
                                    <XMarkIcon
                                        width={30}
                                        className='hover:text-red-500 hover:opacity-100 opacity-50 transition ease-in-out duration-100 cursor-pointer'
                                        onClick={() => {
                                            setShowPopUp(false)

                                        }}
                                    />
                                </div>
                                {/* {page} */}
                            </motion.div>
                        </div>
                    </>,
                    container
                )
            }
        </>
    )
}

export default Popup